/**
 * SSOT for company information used across all PDFs and payslips.
 *
 * Update this single file when the company address, phone, etc. change.
 */

export const COMPANY_INFO = {
  name: "Walia Solutions AG",
  address: "Brunnenwiesenstr. 44\n8610 Uster\nSchweiz",
  phone: "+41 44 515 81 12",
  email: "info@walia-solutions.ch",
  logoPath: "/lovable-uploads/dda4cffb-50ec-4515-a6bc-d72eab19b90f.png",
} as const;
